import { EnquiryKind } from "./ContactFormEntities";

/** Main categorisation entity. */
export interface SectionDefinition {
    label: string;

    /** Type of the enquiry. lost property, general etc. */
    sectionKind: EnquiryKind;
}

export interface EnquiryEntry extends SectionDefinition {
    section: string;
}

/** List of sections. */
export const feedbackSections: Record<EnquiryKind, SectionDefinition> = {
    [EnquiryKind.PleaseSelect]: {
        label: 'Please Select',
        sectionKind: EnquiryKind.PleaseSelect,
    },
    [EnquiryKind.Receipt]: {
        label: 'Receipt',
        sectionKind: EnquiryKind.Receipt,
    },
    [EnquiryKind.Fare_Payment]: {
        label: 'Fare / Payment',
        sectionKind: EnquiryKind.Fare_Payment,
    },
    [EnquiryKind.LostProperty]: {
        label: 'Lost Property',
        sectionKind: EnquiryKind.LostProperty,
    },
    [EnquiryKind.AboutDriver]: {
        label: 'About Driver',
        sectionKind: EnquiryKind.AboutDriver,
    },
    [EnquiryKind.GeneralEnquiry]: {
        label: 'General Enquiry',
        sectionKind: EnquiryKind.GeneralEnquiry,
    },
};